/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const SPECIALTY_ADD = 'SPECIALTY_ADD';
export const SPECIALTY_BEGIN = 'SPECIALTY_BEGIN';
export const SPECIALTY_FAILURE = 'SPECIALTY_FAILURE';
export const SPECIALTY_CLEAR = 'SPECIALTY_CLEAR';

export const SPECIALTY_FILTER_BEGIN = 'SPECIALTY_FILTER_BEGIN';
export const SPECIALTY_FILTER_SUCCESS = 'SPECIALTY_FILTER_SUCCESS';
export const SPECIALTY_FILTER_FAILURE = 'SPECIALTY_FILTER_FAILURE';
export const SPECIALTY_FILTER_CLEAR = 'SPECIALTY_FILTER_CLEAR';

export function fetchSpecialty(params = {}) {
	return async dispatch => {
        dispatch(SpecialtyBegin());
        await ApiService.getSpecialty(params)
			.then(
            result => {
                    dispatch(SpecialtyAdd(result));
				},
				error => {
                    dispatch(SpecialtyError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchSpecialtyFilter(params = {}) {
    return async dispatch => {
        dispatch(specialtyFilterBegin());
        await ApiService.getSpecialtyFilter(params)
            .then(
                result => {
                    dispatch(specialtyFilterAdd(result));
                },
                error => {
                    dispatch(specialtyFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//Specialty
export const SpecialtyBegin = () => ({
    type: SPECIALTY_BEGIN,
});

export const SpecialtyAdd = data => ({
    type: SPECIALTY_ADD,
	payload: { data }
})

export const SpecialtyError = () => ({
    type: SPECIALTY_FAILURE,
})

export const SpecialtyClear = () =>({
    type: SPECIALTY_CLEAR,
})

//Specialty Filters
export const specialtyFilterBegin = () => ({
    type: SPECIALTY_FILTER_BEGIN,
});
export const specialtyFilterAdd = filterData => ({
    type: SPECIALTY_FILTER_SUCCESS,
    payload: { filterData }
})
export const specialtyFilterError = filterError => ({
    type: SPECIALTY_FILTER_FAILURE,
    payload: { filterError }
})

export const specialtyFilterClear = () => ({
    type: SPECIALTY_FILTER_CLEAR,
})
